module.exports = __webpack_public_path__ + "img/book-open-flat.8d7a5f22.svg";